import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class HowToBuildAFollowingPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Promoting Your Profile</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>
                  How to Build a Following
                </div>

                <p>
                  Shadower can provide a valuable source of supplemental income,
                  particularly for those experts who have developed a following
                  on and off the platform.
                </p>

                <div className={s.contentContainer}>
                  <div>
                    <strong>How Favoriting Works</strong>
                  </div>
                  <p>
                    The simplest method to begin acquiring followers is to
                    encourage users to favorite your shadowing profile by
                    clicking on the <b>Favorite</b> button in the top right
                    corner.
                  </p>

                  <p>
                    Every time you create new sessions, users who have favorited
                    your profile will receive an alert notifying them that they
                    should check out your new shadowing opportunities. Users
                    will also receive a friendly reminder at the beginning of
                    each week if you have opportunities available.
                  </p>
                </div>

                <div className={s.contentContainer}>
                  <div>
                    <strong>Tips to Acquire Followers</strong>
                  </div>

                  <ul>
                    <li>
                      Experiment:
                      <p>
                        Experiment with the types of sessions you offer, the
                        titles, your prices and scheduling to find what works
                        best for you and your followers.
                      </p>
                    </li>

                    <li>
                      Keep marketing:
                      <p>
                        Word-of-mouth marketing is one of the most proven
                        methods for results. Encourage your shadowers to refer
                        their friends, family and followers to your profile.
                      </p>
                    </li>

                    <li>
                      Demonstrate your results:
                      <p>
                        Use your various online presences (social media,
                        websites, blogs, etc.) to show off the successes of your
                        shadowers after working with you. Let people know they
                        too can have similar results by working with you.
                      </p>
                    </li>

                    <li>
                      Create a YouTube channel:
                      <p>
                        Post informative videos to YouTube that demonstrate your
                        area of expertise and show how users can benefit by
                        working with you in person through Shadower.
                      </p>
                    </li>

                    <li>
                      Link to Shadower through email:
                      <p>
                        Add a link to your shadowing profile in your email
                        signature so your clients and correspondents know about
                        the additional services you offer.
                      </p>
                    </li>
                  </ul>
                </div>

                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/earning-revenue/how-payment-works"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(HowToBuildAFollowingPage);
